/* istanbul ignore file */
import React from 'react';
import { BreadcrumbItem } from 'framework/ui/BreadCrumbs';
import JournalEntryBreadcrumbs from 'domain/finance/journalEntry/shared/JournalEntryBreadcrumbs';

const ReverseLedgerBreadcrumbs = () => {
  return (
    <JournalEntryBreadcrumbs>
      <BreadcrumbItem>Storno Journal Entry</BreadcrumbItem>
    </JournalEntryBreadcrumbs>
  );
};

export default ReverseLedgerBreadcrumbs;
